import * as React from "react";
import "../index.css";
// import "../Modules/protect/protect.css";
import { Col, Container, Image, Row } from "react-bootstrap";
import Highlights from "../Modules/protect/Highlights";
import Product from "../Modules/home/Product";
import AudioShowcase from "../Modules/protect/AudioShowcase";
import ImageHighlights from "../Modules/protect/ImageHighlights";
import Testimonials from "../Modules/home/testimonials";
import Difference from "../Modules/Difference";
import Process from "../Modules/protect/Process";
import { Helmet } from "react-helmet";
import Teaser from "../Modules/protect/Teaser";
import Footer from "../Modules/Footer";
import NavigationBar from "../Modules/NavigationBar";
import Hero from "../Modules/home/Hero";
import ProductShowcase from "../Modules/ProductShowcase";
import UniqueSellingPoint from "../Modules/UniqueSellingPoint";
import Spacer from "../Modules/Spacer";

export default function Protect() {
	return (
		<>
			<Helmet>
				<title>{"EarsOnly | Protect"}</title>
			</Helmet>
			<NavigationBar />
			<Hero logo="/images/logos/EarsOnlyprotectBLACK.png" />
			<ProductShowcase
				title="/images/logos/Protect.png"
				text="True-Wireless custom fit hearing protection with dynamic damping. Ability to communicate in noisy environments and enjoy high quality music at safe sound levels."
				img="images/cradle_and_buds/cradlebackgroundearbudsfront.png"
				backgroundImage1="images/lifestyle/LifestyleSPARKS.jpg"
				backgroundImage2="images/lifestyle/LifestyleWELDER.jpg"
				backgroundImage3="images/lifestyle/LifestyleGRINDER.jpg"
			/>

			<Container className="container-padding">
				<Difference
					productname="Protect"
					
					differences={[
						{
							image: "/images/highlighticons/Dynamic-protection.png",
							title: "Always protected with Active Awareness",
							text: "Our Dynamic Damping adapts to your surroundings to remain aware and protected. Tuned for clear conversations in noisy environments",
						},
						{
							image: "/images/highlighticons/Custom-fit.png",
							title: "Earbuds designed for maximum comfort",
							text: "Tailored to your ear and crafted with additive manufacturing using bio-compatible resin, ensuring a comfortable and secure fit",
						},
						{
							image: "/images/highlighticons/Hands-free-call.png",
							title: "Hands-free calls in any environment",
							text: "Hands-free calls even in noisy environments using bone conduction technology and advanced noise suppression algorithms",
						},
					]}
				
				/>

				<Spacer />
				<UniqueSellingPoint
					title="Powered by Dopple"
					image="/images/highlighticons/Dopple-inside.png"
					text="Advanced audio protection technology platform designed and engineered in-house to deliver precision performance, reliable protection, and intelligent sound processing."
				/>
				<Spacer />

				<Highlights
					highlights={[
						
						{
							icon: "images/highlighticons/All-day power-3.png",
							bullets: ["8h+ Music with Active Awareness ", "5h+ Call-time ", "Extend to 16h+ with Charging Case", "USB-C & Wireless charging"],
							title: "All-Day Power"
						},
						{
							icon: "images/highlighticons/Protection.png",
							bullets: ["Noise Protection Level of 27dB", "Impulse Protection level up to 38dB", "Always-on protection, even when powered down"],
							title: "Hearing Protection"
						},
						{
							icon: "images/highlighticons/Mobile-app.png",
							bullets: ["Fine-tune your Active Awareness", "Seamless software updates", "Adjust your button layout"],
							title: "Mobile App"
						},
						{
							icon: "images/highlighticons/Dutch-made.png",
							bullets: ["Designed and produced in the Netherlands", "Robust with an IP57-rated Dust & Water-protection"],
							title: "Dutch-made Quality"
						},
						{
							icon: "images/highlighticons/Bluetooth.png",
							bullets: ["Bluetooth® 6.1 provides dependable, hands-free performance", "Active voice assistant"],
							title: "True-wireless Technology"
						},
						{
							icon: "images/highlighticons/HQ-music-2.png",
							bullets: ["Powerful bass and crisp highs from the Dynamic Driver, safely limited to 80dB", "Equalize your music to your liking"],
							title: "High-quality Music"
						},
					]}
					largeRow={3}
				/>

			</Container>
			<Footer />
		</>
	);
}
